module.exports = __webpack_public_path__ + "static/crCooper-4db27a7d74ad87f6100208f285a3b962.webp";